import trackActivity from "./auditTracker";

export const logActivitySafe = (payload: {
  module: string;
  action: string;
  description?: string;
}) => {
  // Fire-and-forget
  // Uses setTimeout to ensure it runs in the next tick and doesn't block main thread/navigation
  setTimeout(() => {
    trackActivity(payload);
  }, 0);
};
